import { styled, Grid, useMediaQuery } from '@mui/material';
import React from 'react';
import { AnalyticsTrackingEvent } from '../../analytics/events.js';
import brandclub_colors from '../../colors/brandclubColors.js';
import { TABLET_SCREEN_SIZE, WIDGET_SPACE_HALF, TABLET_HORIZONTAL_PADDING, MOBILE_SCREEN_SIZE, MOBILE_HORIZONTAL_PADDING, WIDGET_SPACE, DESKTOP_SCREEN_SIZE, DESKTOP_HORIZONTAL_PADDING } from '../../utils/constants/Constants.js';
import { sendTextCallback } from '../../utils/textMessage.js';
import BrandclubPhoneInput from '../components/BrandclubPhoneInput/index.js';
import { GenericContainer } from '../components/GenericContainer.js';

var _a, _b, _c, _d, _e;
var BrandclubAppDownloadContainer = styled(GenericContainer)((_a = {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        paddingTop: WIDGET_SPACE,
        paddingBottom: WIDGET_SPACE,
        paddingLeft: '5%',
        paddingRight: '5%',
        boxSizing: 'border-box'
    },
    _a["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
        backgroundColor: '#fff',
        padding: "".concat(WIDGET_SPACE_HALF, "px ").concat(TABLET_HORIZONTAL_PADDING, "px"),
    },
    _a["@media screen and (max-width: ".concat(MOBILE_SCREEN_SIZE, "px)")] = {
        backgroundColor: '#fff',
        padding: "".concat(WIDGET_SPACE_HALF, "px ").concat(MOBILE_HORIZONTAL_PADDING, "px"),
    },
    _a));
var OverviewContent = styled(Grid)((_b = {
        maxWidth: DESKTOP_SCREEN_SIZE - DESKTOP_HORIZONTAL_PADDING * 2,
        color: brandclub_colors.mainSeriesColor,
        width: '100%',
        position: 'relative',
        justifyContent: 'space-between',
        flexDirection: 'row',
        gap: '50px'
    },
    _b["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
        flexDirection: 'column',
    },
    _b));
var InfoContainer = styled(Grid)((_c = {
        width: 500,
        maxWidth: 500,
        minWidth: 500
    },
    _c["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
        maxWidth: 400,
        width: '100%',
        minWidth: 'auto',
    },
    _c['.title'] = (_d = {
            fontSize: 50,
            fontWeight: 700,
            lineHeight: 1.2
        },
        _d["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
            fontSize: 26,
            textAlign: 'center',
            padding: '0 20px',
        },
        _d),
    _c['.subtitle'] = (_e = {
            marginTop: 20,
            lineHeight: 1.6,
            fontSize: 24,
            fontWeight: 500
        },
        _e["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
            fontSize: 16,
            textAlign: 'center',
            padding: '0 20px',
        },
        _e),
    _c));
var ImageContainer = styled(Grid)({
    maxWidth: 660,
    img: {
        width: '100%',
    },
});
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var BrandclubAppDownload = function (_a) {
    var _b;
    var _c = _a.title, title = _c === void 0 ? 'Get the Brandclub mobile app' : _c, _d = _a.subtitle, subtitle = _d === void 0 ? '' : _d, useSearchParams = _a.useSearchParams, trackingParams = _a.trackingParams, analyticsTrack = _a.analyticsTrack, mainEntity = _a.mainEntity, axios = _a.axios, brandEntity = _a.brandEntity, userProfile = _a.userProfile;
    var searchParams = useSearchParams()[0];
    var desktopView = useMediaQuery("(min-width:".concat(TABLET_SCREEN_SIZE, "px)"));
    var prefix = 'https://app.brandclub.com/';
    var referralCode = searchParams.get('referralCode') || '';
    var defaultSubtitle = "Download the app to earn cash rewards from ".concat((_b = brandEntity === null || brandEntity === void 0 ? void 0 : brandEntity.entity) === null || _b === void 0 ? void 0 : _b.name, ".");
    var qrCodeUrl = referralCode ? "".concat(prefix, "?referralCode=").concat(referralCode) : prefix;
    return (React.createElement(BrandclubAppDownloadContainer, null,
        React.createElement(OverviewContent, { container: true, wrap: "nowrap", alignItems: 'center' },
            React.createElement(InfoContainer, { flex: 1 },
                React.createElement("div", { className: "title" }, title),
                React.createElement("div", { className: "subtitle" }, subtitle ? subtitle : defaultSubtitle),
                React.createElement(Grid, { container: true, flexDirection: 'row', wrap: "nowrap", gap: '15px', justifyContent: "center", alignItems: "center", marginTop: desktopView ? '50px' : '20px' },
                    React.createElement(BrandclubPhoneInput, { userProfile: userProfile, qrCodeUrl: qrCodeUrl, handleSendText: function (phoneNumber) {
                            return sendTextCallback(phoneNumber, axios, mainEntity, analyticsTrack, trackingParams, AnalyticsTrackingEvent.WEB_APP_SOCIAL_LINK_TEXT_APP_DOWNLOAD_LINK);
                        } }))),
            React.createElement(ImageContainer, { flex: 1 },
                React.createElement("img", { loading: "lazy", src: "https://media.brandclub.com/brand_custom/".concat(brandEntity === null || brandEntity === void 0 ? void 0 : brandEntity.id, "/getAppTop.png"), alt: "" })))));
};

export { BrandclubAppDownload };
//# sourceMappingURL=index.js.map
